<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      :height="400"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:top>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="left"
        >
          <i class="el-icon-delete tool-btn" @click="del(row)" />
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    del(row) {
      this.$refs.table.remove(row)
    },
    getTableData() {
      const { tableData } = this.$refs.table.getTableData() || {}
      return tableData || []
    },
    insertAt(records, row = -1) {
      return this.$refs.table.insertAt(records, row)
    },
  },
}
</script>
